// Module
var code = "<p>Enabling summary survey notifications, our system notifies you by email at certain intervals in order to avoid a crowded inbox.</p> <p>The email will be sent to the email you used upon registration.</p> ";
// Exports
module.exports = code;